package com.exura.features.publicplans.data.remote.dto

import com.exura.features.plandefinition.domain.model.PlanContentSummary
import com.exura.features.publicplans.domain.model.PublicPlanStatistics
import com.exura.features.storage.domain.model.ModelDto
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class ProviderPublicPlanDto(
    val globalEntryId: String,
    val isSharingEnabled: Boolean,
    val websiteLink: String,
    val qrCodeUri: String,
    val accessCode: String,
    val createdDate: String,
    val lastModifiedDate: String,
    val summary: PlanContentSummary,
    val statistics: PublicPlanStatistics,
) : ModelDto<ProviderPublicPlanDto> {
    @Transient
    override val serializer = serializer()
}
